(() => {
  const sections = document.querySelectorAll('[data-article-main]');

  sections.forEach((section) => {
    const content = section.querySelector('[data-article-content]');
    const toc = section.querySelector('[data-article-toc]');

    if (!content || !toc) return;

    const isManualToc = toc.dataset.manualToc === 'true';
    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => {
      return heading.textContent.trim().length > 0;
    });

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '') || `article-heading-${index + 1}`;
      }

      if (!isManualToc) {
        const item = document.createElement('li');
        const link = document.createElement('a');

        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.className = `article-main__toc-link article-main__toc-link--${heading.tagName.toLowerCase()}`;

        item.append(link);
        toc.append(item);
      }
    });

    if (!headings.length || !('IntersectionObserver' in window)) return;

    const links = [...toc.querySelectorAll('a')];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          links.forEach((link) => link.classList.remove('is-active'));
          const activeLink = toc.querySelector(`a[href="#${CSS.escape(entry.target.id)}"]`);
          if (activeLink) activeLink.classList.add('is-active');
        });
      },
      { rootMargin: '-25% 0px -65% 0px' }
    );

    headings.forEach((heading) => observer.observe(heading));
  });

  document.querySelectorAll('[data-article-share]').forEach((button) => {
    const label = button.querySelector('[data-share-label]');
    const originalLabel = label ? label.textContent : '';

    button.addEventListener('click', async () => {
      const title = button.dataset.shareTitle || document.title;
      const url = button.dataset.shareUrl || window.location.href;

      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          return;
        }

        await navigator.clipboard.writeText(url);
        if (label) label.textContent = 'Link copied';
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel;
        }, 1800);
      } catch (error) {
        window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
      }
    });
  });
})();